// @ts-nocheck
import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Grid,
  Container,
  Paper,
  Tooltip,
  InputBase,
  IconButton,
  LinearProgress,
  ClickAwayListener,
  CircularProgress,
} from "@mui/material";
import "reactjs-popup/dist/index.css";
import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import usePoolsPageContext from "../../context/usePoolsPageContext.js";
import { useHistory, useLocation } from "react-router-dom";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";
import {
  BodyLarge,
  H7TitleLarge,
} from "../../../components/StyledComponents/Typography/Typography.tsx";

import { Switch, Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import {
  PoolsPageContext,
  PoolsPageContextProvider,
} from "../../context/PoolsPageContextProvider.js";

import DataGrid from "../../../components/DataGrid/DataGrid.tsx";
import {StyledMenu, StyledMenuItem} from "../../../components/StyledComponents/Menu/Menu.tsx";

import {
  PrimaryButton,
  StyledIconButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { useAuth0 } from "@auth0/auth0-react";
import MoreVertIconRounded from "@mui/icons-material/MoreVertRounded";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import ActionDialog from "../../../components/ActionDialog/ActionDialog.js";
import { AddAccessListsDialog } from "../../Components/AddAccessListsDialog/AddAccessListsDialog.js";
import { usePostOrg } from "../../../api/queries/usePostOrg.ts";
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";
import AuradineErrorState from "../../../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import { usePostDeletedAcceptedPools } from "../../queries/usePostDeleteAcceptedPools.ts";
import { GridNoRowsOverlay } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { GetUserUseQuery } from "../../../api/api.js";
import PageWrapper from "../../../components/PageWrapper/PageWrapper.js";

const queryClient = new QueryClient();

export const WhiteListsMenu = (props) => {
  const { colors } = useTheme();
  const { rowInfo, userRole } = props;
  const {
    setEditWhiteListsOn,
    setOpenWhiteListsDeletionDialog,
    setDeletionHeaderMessage,
    setDeletionSubHeaderMessage,
    setWhiteListToDelete,
    setOpenAccessListsDialog,
    setAccessListEditIndex,
  } = usePoolsPageContext();

  const buttonRef = React.useRef(null);
  const [anchorEl, setMenuAnchorEl] = React.useState(null);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(buttonRef.current);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleMenuItemClick = (action, row) => {
    switch (action) {
      case "edit":
        setAccessListEditIndex(rowInfo.id);
        setMenuAnchorEl(null);
        setEditWhiteListsOn(true);
        setWhiteListToDelete(rowInfo);
        setOpenAccessListsDialog(true);
        break;
      case "delete":
        setAccessListEditIndex(rowInfo.id);
        setMenuAnchorEl(null);
        setOpenWhiteListsDeletionDialog(true);
        setDeletionHeaderMessage(
          `Delete from your Whitelist Pools List?`
        );
        setDeletionSubHeaderMessage(
          `Are you sure you want to delete ${rowInfo.user}, ${rowInfo.url}? This action cannot be undone.`
        );
        setWhiteListToDelete(rowInfo);
        break;
      default:
        return;
    }
  };

  return (
    <>
      <StyledIconButton   
        colors={colors}
        ref={buttonRef}
        // id={`more-vert${params.row.id}`}
        onClick={handleMenuOpen}
      >
        <MoreVertIconRounded />
      </StyledIconButton>
      <ClickAwayListener onClickAway={handleMenuClose}>
        <StyledMenu
          colors={colors}
          // sx={{ boxShadow: "none !important" }}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 1,
            sx: {
              "&.MuiPaper-root": {
                boxShadow:
                  "0px 1px 1px 0px lightgrey, 0px 1px 1px 1px lightgrey",
              },
            },
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {/* <StyledMenuItem
            onClick={() =>
              handleMenuItemClick("edit", rowInfo)
            }
          >
            Edit
          </StyledMenuItem> */}
          <StyledMenuItem
            colors={colors}
            onClick={() =>
              handleMenuItemClick("delete", rowInfo)
            }
            disabled={userRole === "pooladmin"}
          >
            Delete
          </StyledMenuItem>
        </StyledMenu>
      </ClickAwayListener>
    </>
  );
};

export const HeaderContainer = React.memo((props) => {
  const { data } = props;
  const { colors } = useTheme();
  const navigate = useHistory();

  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={2.48}
      marginBottom={"1.5rem"}
    >
      <Box
        display="flex"
        flexDirection="column"
        minWidth={"2.98rem"}
        justifyContent="flex-start"
        alignItems={"center"}
      >
        <StyledIconButton  colors={colors} onClick={() => navigate.goBack()}>
          {" "}
          <ArrowBackIosNewIcon
            fontSize="medium"
          />{" "}
        </StyledIconButton>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        gap={4}
        justifyContent="flex-start"
      >
        <H7TitleLarge>Whitelist Pools List</H7TitleLarge>
        <BodyLarge>
          Manage domains and users outside your
          organization's domain that are trusted to access
          FluxVision.
        </BodyLarge>
      </Box>
    </Box>
  );
});

const WhiteListsPageHeader = () => {
  const {
    accessLists,
    setAccessLists,
    accessListsCopy,
    setOpenAccessListsDialog,
    searchValue,
    setSearchValue,
  } = usePoolsPageContext();
  const { colors } = useTheme();
  const handleDialogOpen = () => {
    setOpenAccessListsDialog(true);
  };
  useEffect(() => {
    if (searchValue) {
      const changedAccessLists = accessListsCopy.filter(
        (item) => {
          return (
            item.user.includes(searchValue) ||
            item.url.includes(searchValue)
          );
        }
      );
      setAccessLists(changedAccessLists);
    } else {
      setAccessLists(accessListsCopy);
    }
  }, [searchValue, accessListsCopy, setAccessLists]);

  return (
    <Box
      display={"grid"}
      justifyContent={"space-between"}
      gridTemplateColumns={"1fr 1fr"}
    >
      <Box display={"grid"} gridTemplateColumns={"2fr 1fr"}>
        <Paper
          component="form"
          elevation={0}
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            backgroundColor: colors?.background?.secondary,  
            borderRadius: "1.75rem",
            paddingLeft: "1rem",
          }}
        >
          <Tooltip
            // title={searchValue}
            disableFocusListener
            disableTouchListener
          >
            <InputBase
              sx={{ flex: 1, minWidth: "22.5rem", color: colors?.text?.primary  }}
              value={searchValue}
              placeholder="Search for user or URL"
              onChange={(event) => {
                setSearchValue(event.target.value);
                if (event.target.value) {
                  const changedAccessLists =
                    accessListsCopy.filter((item) => {
                      return (
                        item.user.includes(
                          event.target.value
                        ) ||
                        item.url.includes(
                          event.target.value
                        )
                      );
                    });
                  setAccessLists(changedAccessLists);
                } else {
                  setAccessLists(accessListsCopy);
                }
              }}
              inputProps={{
                "aria-label": "search",
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                }
              }}
            />
          </Tooltip>
          <StyledIconButton 
            colors={colors}
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
          >
            <SearchIcon />
          </StyledIconButton>
        </Paper>
      </Box>
      <Box display={"grid"} justifyContent={"end"}>
        <PrimaryButton colors={colors} onClick={handleDialogOpen}>
          Add
        </PrimaryButton>
      </Box>
    </Box>
  );
};

/**
 * Represents the MinerPage component.
 * This component displays a table of miner devices and provides functionality to interact with them.
 */
function WhiteListsPageContent() {
  const { colors } = useTheme();
  const tableContainerRef = React.useRef(null);
  const [authToken, setAuthToken] = useState("");
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();

  const {
    accessLists,
    setAccessLists,
    setAccessListsCopy,
    openWhiteListsDeletionDialog,
    setOpenWhiteListsDeletionDialog,
    deletionHeaderMessage,
    deletionSubHeaderMessage,
    whiteListToDelete,
  } = usePoolsPageContext();

  const { setToastMessage, setToastOpen } =
    useAppContextProvider();

  const { mutate: DeleteAccessList } =
    usePostDeletedAcceptedPools();

  const handleDeletionDialogClose = () => {
    setOpenWhiteListsDeletionDialog(false);
  };

  const {
    data: userInfo,
    isFetched: isUserInfoFetched,
    isFetching: isUserInfoFetching,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => GetUserUseQuery(authToken),
    enabled: !!authToken,
  });

  const userRole = useMemo(() => {
    return isUserInfoFetched
      ? userInfo?.user?.role || ""
      : "";
  }, [isUserInfoFetched, userInfo]);

  // const testResult = Array.from(
  //   { length: 100 },
  //   (_, index) => ({
  //     id: index + 1,
  //     user: `miningRobot${index + 1}`,
  //     url: `http://stratum${index + 1}`,
  //   })
  // );

  const projection = { acceptedPoolUrls: 1 };

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const siteOrGroupConfig = {};

  const {
    data: accessListsData,
    refetch: accessListsRefetch,
    isLoading: isAccessListsLoading,
    isFetching: isAccessListsFetching,
    isFetched: isAccessListsFetched,
    isRefetching: isAccessListsRefetching,
    isError: isAccessListsError,
    isRefetched: isAccessListsRefetched,
  } = usePostOrg({
    open: true,
    authToken,
    ...{
      projection: projection,
    },
  });

  useEffect(() => {
    let testResult = [];
    if (isAccessListsFetched && accessListsData?.result) {
      testResult =
        accessListsData?.result?.acceptedPoolUrls &&
        accessListsData?.result?.acceptedPoolUrls.length >
          0 &&
        accessListsData?.result?.acceptedPoolUrls.map(
          (item, index) => {
            console.log("item", item);
            console.log("index", index);
            const [url, user] = item.split(",");
            return {
              id: index,
              user: user,
              url: url,
            };
          }
        );
    }
    setAccessLists(testResult);
    setAccessListsCopy(testResult);
  }, [
    accessListsData,
    isAccessListsFetched,
    isAccessListsRefetched,
  ]);

  const handleDeleteAction = async () => {
    const { user, url } = whiteListToDelete;
    const deletionUrl = `${url},${user}`;
    const deleteionBody = {
      key: "url",
      value: deletionUrl,
    };
    DeleteAccessList(
      {
        key: deleteionBody.key,
        value: deleteionBody.value,
      },
      {
        onSuccess: async (data) => {
          if (data?.status === "ok") {
            setToastMessage(
              `Successfully deleted ${deletionUrl} from your Whitelist Pool List`
            );
            setToastOpen(true);
            await accessListsRefetch();
            setOpenWhiteListsDeletionDialog(false);
          } else {
            setToastMessage(
              `Failed to delete ${deletionUrl} from your Whitelist Pool List. ${data?.msg}`
            );
            setToastOpen(true);
          }
        },
        onError: (error) => {
          setToastMessage(
            `Failed to delete ${deletionUrl} from your Whitelist Pool List.${error}`
          );
          setToastOpen(true);
        },
      }
    );

    setOpenWhiteListsDeletionDialog(false);
  };

  const columns = [
    {
      field: "user",
      headerName: "User",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "url",
      headerName: "URL",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "",
      headerName: "",
      width: 20,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return <></>;
      },
      renderCell: (params) => {
        return (
          <>
            <WhiteListsMenu
              rowInfo={params.row}
              userRole={userRole}
            />
          </>
        );
      },
    },
  ];

  const CustomGridRowsOverlay = () => {
    if (
      typeof accessListsData === "object" &&
      accessListsData !== null &&
      accessListsData.status.toLowerCase() === "ok" &&
      isAccessListsFetched &&
      typeof accessListsData?.result === "object" &&
      accessListsData?.result !== null &&
      (!Array.isArray(
        accessListsData?.result?.acceptedPoolUrls
      ) ||
        accessListsData.result.acceptedPoolUrls.length ===
          0)
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
              backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          No data available
        </Box>
      );
    }
    if (
      isAccessListsError === true ||
      (isAccessListsFetched === true &&
        typeof accessListsData?.status === "string" &&
        accessListsData.status.toLowerCase() === "error")
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          <AuradineErrorState
            message={`Error: ${accessListsData.msg}`}
          />
        </Box>
      );
    }
  };

  const dataGridProps = {
    rows: Array.isArray(accessLists) ? accessLists : [],
    columns,
    disableColumnMenu: true,
    hideFooterPagination: true,
    hideFooter: true,
    loading:
      isAccessListsLoading ||
      isAccessListsFetching ||
      isAccessListsRefetching,
    disableSelectionOnClick: true,
    disableCellSelection: true,
    overlayNoRowsTemplate: "No data available",
    slots: {
      noRowsOverlay: CustomGridRowsOverlay,
    },
    slotProps: {
      loadingOverlay: {
        variant: "linear-progress",
        noRowsVariant: "skeleton",
        sx: {
          backgroundColor: colors.background.paper,
        },
      },
    },
  };

  return (
    <PageWrapper>
      <HeaderContainer />
      <Grid
        container
        className={"miner-page-table-container"}
        display={"flex"}
        flexDirection={"row"}
        spacing={4}
        sx={{ transition: "all 0.3s ease-in-out" }}
      >
        <Grid
          ref={tableContainerRef}
          item
          xs={12}
          sx={{
            transition: "width 0.3s ease-in-out", // Smooth transition for width
          }}
        >
          <Box
            className={"miner-page-table"}
            display={"flex"}
            flexDirection={"row"}
            backgroundColor={colors.background.paper}
            padding={"0.75rem 0  0.75rem 0"}
            borderRadius={"1rem"}
            sx={{
              transition: "width 0.3s ease-in-out", // Smooth transition for width
            }}
          >
            {isUserInfoFetching ||
            isAccessListsFetching ||
            isAccessListsLoading ||
            isAccessListsLoading ? (
              <Box
                display={"flex"}
                flexGrow={1}
                justifyContent={"center"}
                alignItems={"center"}
                height="calc(100vh - 17rem)"
              >
                <CircularProgress
                  size={"3rem"}
                  sx={{
                    color: colors.primary.main,
                  }}
                />
              </Box>
            ) : isUserInfoFetched &&
              isAccessListsFetched &&
              !isAccessListsLoading &&
              !isUserInfoFetching &&
              !isAccessListsFetching &&
              userRole &&
              ["superadmin", "pooladmin"].includes(
                userRole
              ) ? (
              <Box
                className={"table-container"}
                display={"flex"}
                flexDirection={"column"}
                padding={"0 0.75rem 0 0.75rem"}
                height={"auto"}
                // overflow={"auto"}
                minWidth={"0"}
                gap={4}
                flex={3}
                flexShrink={1}
              >
                <WhiteListsPageHeader />

                <Box
                  className={"Datagrid-container"}
                  display={"flex"}
                  flexShrink={1}
                  flexGrow={1}
                  overflowY={"auto"}
                  height="calc(100vh - 17rem)"
                >
                  <DataGrid
                    colors={colors}
                    config={dataGridProps}
                    height="calc(100vh - 19rem)"
                  />
                </Box>
              </Box>
            ) : (
              isUserInfoFetched &&
              isAccessListsFetched && (
                <Box
                  display={"flex"}
                  flexGrow={1}
                  flexDirection={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  height="calc(100vh - 17rem)"
                >
                  <AuradineErrorState
                    message={`You do not have access to this page.`}
                  />
                </Box>
              )
            )}
            {openWhiteListsDeletionDialog && (
              <ActionDialog
                open={openWhiteListsDeletionDialog}
                onClose={handleDeletionDialogClose}
                headerMessage={deletionHeaderMessage}
                subMessage={deletionSubHeaderMessage}
                buttonText={"Delete"}
                deleteAction={handleDeleteAction}
              />
            )}
            <AddAccessListsDialog
              refetch={accessListsRefetch}
            />
          </Box>
        </Grid>
      </Grid>
    </PageWrapper>
  );
}

export default function WhiteListsPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <PoolsPageContextProvider>
        <WhiteListsPageContent />
      </PoolsPageContextProvider>
    </QueryClientProvider>
  );
}
